"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DropdownUtil {
    static dateHasPassedThreshold(date) {
        return !date || (date.getTime() + DropdownUtil.EVENT_TIMEOUT_MS) < new Date().getTime();
    }
    static getOptionIndexMapKeys(map) {
        return Array.from(map.keys());
    }
}
DropdownUtil.EVENT_TIMEOUT_MS = 150;
exports.default = DropdownUtil;
//# sourceMappingURL=DropdownUtil.js.map